import {BaseDTO} from "../_baseDTO.interface";

export interface UnverifiedContactDTO extends BaseDTO {
  contactName?: string;
  email?: string;
  phone?: string;
  added?: Date;
}
